export default __webpack_public_path__ + "static/media/select_max.1b617627.gif";